import { takeLatest, call, put, select } from 'redux-saga/effects';
import { push } from 'connected-react-router';

// Services
import { printModelApi } from 'services/apiDigitalTicket/printModel';

// Actions
import * as DialogsActions from 'store/ducks/dialogs/actions';
import * as SnackbarsActions from 'store/ducks/snackbars/actions';

// Constants
import { errorMessagersList } from 'helpers/errorMessagers';
import PATH from 'constants/basePath';

import * as PrintModelActions from './actions';
import { PrintModelTypes } from './types';

function* list({
  payload,
}: ReturnType<typeof PrintModelActions.listPrintModelsRequest>): any {
  try {
    yield put(DialogsActions.setOpenLoading({ title: 'Carregando dados' }));
    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );
    const response = yield call(printModelApi.get, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        PrintModelActions.listPrintModelsSuccess({ printModelsList: response.data }),
      );
      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('printModel - getPrintModel - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(PrintModelActions.listPrintModelsFailure());
    yield put(DialogsActions.setClose());
  }
}

function* create({
  payload,
}: ReturnType<typeof PrintModelActions.createPrintModelRequest>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({ title: 'Criando Modelo de Impressão' }),
    );
    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );
    const response = yield call(printModelApi.create, {
      data: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        PrintModelActions.createPrintModelSuccess({ printModelData: response.data }),
      );
      yield put(DialogsActions.setClose());
      yield put(
        SnackbarsActions.setOpen({
          open: true,
          type: 'success',
          message: 'Modelo de Impressão criado com sucesso',
        }),
      );

      yield put(PrintModelActions.listPrintModelsRequest({}));
      yield put(push(PATH.PRINT_MODEL.BASE_URL));
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('printModel - createPrintModel - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(PrintModelActions.createPrintModelFailure());
    yield put(DialogsActions.setClose());
  }
}

function* update({
  payload,
}: ReturnType<typeof PrintModelActions.updatePrintModelRequest>): any {
  try {
    yield put(DialogsActions.setOpenLoading({ title: 'Editando Modelo de Impressão' }));
    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );
    const response = yield call(printModelApi.update, {
      data: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        PrintModelActions.updatePrintModelSuccess({ printModelData: response.data }),
      );
      yield put(DialogsActions.setClose());
      yield put(
        SnackbarsActions.setOpen({
          open: true,
          type: 'success',
          message: 'Modelo de Impressão alterado com sucesso',
        }),
      );
      yield put(push(PATH.PRINT_MODEL.BASE_URL));
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('printModel - updatePrintModel - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(PrintModelActions.updatePrintModelFailure());
    yield put(DialogsActions.setClose());
  }
}

function* deletePrintModel({
  payload,
}: ReturnType<typeof PrintModelActions.deletePrintModelRequest>): any {
  try {
    yield put(DialogsActions.setOpenLoading({ title: 'Excluindo Modelo de Impressão' }));
    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );
    const response = yield call(printModelApi.delete, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(PrintModelActions.deletePrintModelSuccess());
      yield put(DialogsActions.setClose());
      yield put(
        SnackbarsActions.setOpen({
          open: true,
          type: 'success',
          message: 'Modelo de Impressão excluído com sucesso',
        }),
      );
      window.location.reload();
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('printModel - deletePrintModel - error', error);
    yield put(
      SnackbarsActions.setOpen({
        message,
        open: true,
        type: 'error',
      }),
    );
    yield put(PrintModelActions.deletePrintModelFailure());
    yield put(DialogsActions.setClose());
  }
}



// eslint-disable-next-line import/prefer-default-export
export const printModelSagas = [
  takeLatest(PrintModelTypes.LIST_PRINT_MODELS_REQUEST, list),
  takeLatest(PrintModelTypes.CREATE_PRINT_MODEL_REQUEST, create),
  takeLatest(PrintModelTypes.UPDATE_PRINT_MODEL_REQUEST, update),
  takeLatest(PrintModelTypes.DELETE_PRINT_MODEL_REQUEST, deletePrintModel),
];
